export const texts = {
  title: {
    de: 'Berufserfahrung',
    en: 'Work experience'
  },
  noInformation: {
    de: 'Es liegen keine Angaben vor',
    en: 'No information available'
  },
  to: {
    de: 'bis',
    en: 'to'
  },
  toPresent: {
    de: 'bis heute',
    en: 'to present'
  },
  aboutOneMonth: {
    de: 'ca. ein Monat',
    en: 'approx. one month'
  },
  unknownDuration: {
    de: 'unbekannte Dauer',
    en: 'unknown duration'
  }
};
